import { gql } from "@apollo/client";

export const SEND_RENTAL_AGREEMENT = gql`
  mutation sendRentalAgreement($id: String!, $additionalMails: [String]) {
    sendRentalAgreement(id: $id, additionalMails: $additionalMails)
  }
`;